import React from 'react'
import { Card, Row, Col, Radio, Space, Button  } from 'antd';

function TestBox(props) {
    const {index, data, opts, answer} = props || ''
    let {
        question,
    } = data
    const onChange = (e) =>{
        props.setAnswer(e.target.value)
    }
  return (
            <Card  
            style={{marginBottom:'10px',}}
            actions={[
                <Button  onClick={()=>props.moveBackward()}>Previous</Button >,
                <Button type="danger" onClick={()=>props.showDrawer()}>Jump</Button>,
                <Button type="warning" onClick={()=>props.pause()}>Pause</Button>,
                <Button type="primary" onClick={()=>props.submit()}>Submit</Button>,
                <Button  onClick={()=>props.moveForward()}>Next</Button>,  
                ]}
            >
                <Row gutter={16} style={{minHeight:'200px', marginLeft:'30px', marginRight:'30px'}}>
                <Col span={24}>
                <div style={{display:'flex', flexDirection:'row'}}>
                <div style={{marginLeft:'20px', marginRight:'20px'}}>{`${index + 1} . ${"  "} `}</div>                   
                <div style={{whiteSpace:'pre-wraps'}}  dangerouslySetInnerHTML={{__html: question}} />
                </div>                  
                </Col>
                <Col span={24} style={{paddingLeft:'50px'}}>
                <Radio.Group defaultValue={answer} style={{ width: '100%', buttonStyle:'solid' }} buttonStyle="solid" onChange={onChange}>
                <Space direction="vertical">
                    {
                        opts.map((p, i)=>{
                            return <><Radio value={p.alp}>
                                <div key={i} style={{display:'flex', flexDirection:'row'}}>
                            <div style={{marginLeft:'20px', marginRight:'20px'}}>{`${p.alp} . ${"  "} `}</div>                   
                            <div style={{whiteSpace:'pre-wraps'}}  dangerouslySetInnerHTML={{__html: p.text}} />
                            </div> 
                            </Radio>
                             <br /></>
                        })
                    }
                </Space>
                </Radio.Group> 
                </Col>
            </Row>
           
           </Card>
  )
}

TestBox.propTypes = {}

export default TestBox
